<template>
  <tr>
    <td class="text-left">
      <div class="row">
        <div class="col-12 row">
          <div class="col-12">
            <span class="font-weight-bold"
              >{{ $t("app.modules.add_by_part_number.part_number") }}:
            </span>
            <span>{{ item.producto.material }} - </span>
            <span v-if="!isDropDown">{{
              item.producto.producto.textoBreveMaterial
            }}</span>
          </div>
        </div>

        <!--

        <div class="col-12 row" v-if="!isDropDown">
          <div class="col-12">
            <span class="font-weight-bold">{{$t("app.modules.orders.form.delivery_address")}}: </span>
            {{item.producto.direccionEntrega.direccionString}}
          </div>
        </div>
        -->
      </div>
    </td>
    <td class="text-center">
      <template v-if="!isDropDown">
        <el-input-number
          @blur="itemChangeDate(item)"
          :controls="false"
          v-model="item.cantidad"
          :min="1"
          :disabled="editable"
        >
        </el-input-number>
      </template>
      <template v-if="isDropDown">
        {{ item.cantidad }}
      </template>
    </td>
    <td class="text-center" v-if="!isDropDown">
      <template>
        {{ item.producto.unidadMedida }}
      </template>
    </td>
    <td class="text-center" v-if="!isDropDown">
      <template>
        <div class="form-group">
          <fg-input class="mi-item">
            <el-date-picker
              :clearable="false"
              @blur="itemChangeDate(item)"
              v-model="item.fechaEntrega"
              format="MM-dd-yyyy"
              type="date"
              :picker-options="pickerOptions"
              :disabled="editable"
            />
          </fg-input>
        </div>
      </template>
    </td>
    <td class="td-actions" v-if="!isDropDown">
      <!--
      <button
        type="button"
        rel="tooltip"
        title=""
        class="btn btn-danger btn-round btn-icon btn-icon-mini btn-neutral"
        data-original-title="Remove"
        @click="removeItem(item.idCartItem)"
        v-if="!editable"
      >
        <i class="fa fa-trash"></i>
      </button>
      -->

      <n-button
        native-type="button"
        type="danger"
        :title="$t('app.buttons.add')"
        @click.native="removeItem(item.idCartItem)"
        size="sm"
        v-if="!editable"
      >
        <!--
                              <i class="fa fa-minus"></i>
                              -->

        {{ $t("app.buttons.delete") }}
      </n-button>
    </td>
    <td class="text-center" v-if="!isDropDown">
      <span class="text-dark font-weight-bold"
        >${{ item.producto.precioUnitario | currenciFormat() }}</span
      >
    </td>
    <td class="text-center" v-if="!isDropDown">
      <span class="text-dark font-weight-bold"
        >${{
          (item.producto.precioUnitario * item.cantidad) | currenciFormat()
        }}</span
      >
    </td>
    <td v-if="!isDropDown"></td>
    <td class="text-center" v-if="!isDropDown">
      <template>
        {{ item.producto.moneda }}
      </template>
    </td>
  </tr>
</template>

<script>
let moment = require("moment");
export default {
  name: "cartItemRow",
  props: {
    item: Object,
    isDropDown: Boolean,
    editable: Boolean,
  },
  watch: {
    editable(newvalue, oldvalue) {
      this.editable = newvalue;
    },
  },
  mounted() {},
  methods: {
    removeItem(itemId) {
      EventBus.$emit("remove-from-cart", itemId);
    },
    itemChangeCantidad(item) {
      console.log("itemchangedate ---> " + JSON.stringify(item));
      console.log(item);
    },
    itemChangeDate(item) {
      console.log("itemchangedate ---> " + JSON.stringify(item));
      EventBus.$emit("update-cart-item", {
        idCartItem: item.idCartItem,
        cantidad: item.cantidad,
        fechaEntrega: item.fechaEntrega,
        idProductoCliente: item.idProductoCliente,
        idPedido: item.idPedido,
      });
    },
  },
  watch: {
    /*
    "item.cantidad": function(newVal){
      var formatedDate = moment(this.item.fechaEntrega).format("YYYY-MM-DD");
      EventBus.$emit("update-cart-item", {idCartItem: this.item.idCartItem, cantidad: newVal,fechaEntrega: formatedDate});
    },
    "item.fechaEntrega": function (newVal){
      var formatedDate = moment(newVal).format("YYYY-MM-DD");
      EventBus.$emit("update-cart-item", {idCartItem: this.item.idCartItem, cantidad: this.item.cantidad,fechaEntrega: formatedDate});
    }*/
  },
  filters: {
    currenciDecimalFormat(amount) {
      if (amount) {
        let decimalCount = 2;
        let decimal = ".";
        let thousands = ",";

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(
          (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
        ).toString();
        let j = i.length > 3 ? i.length % 3 : 0;

        return (
          negativeSign +
          (j ? i.substr(0, j) + thousands : "") +
          i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
          (decimalCount
            ? decimal +
              Math.abs(amount - i)
                .toFixed(decimalCount)
                .slice(2)
            : "")
        );
      }
      return null;
    },
    currenciFormat(value) {
      if (value) {
        let val = (value / 1).toFixed(2).replace(",", ".");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return null;
    },
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          var fechatest = new Date();
          fechatest.setDate(fechatest.getDate() + 30);
          return time.getTime() < fechatest;
        },
      },
    };
  },
};
</script>
<style>
.form-group .mi-item .el-input__inner {
  background-color: black !important;
  color: white;
}
</style>
